import { t } from "../../../../i18n";
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Avatar, Box, Chip, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { IconLogout, IconSettings, IconUser } from '@tabler/icons-react';
import { useAuth } from '../../../../auth/AuthProvider';
import { portalConfig } from '../../../../configs/portal';
const icons = {
  settings: IconSettings,
  profile: IconUser
};
const accountItemSx = {
  mt: 0.5,
  borderRadius: '5px',
  color: 'primary.main',
  '& .MuiListItemText-primary': {
    color: 'inherit'
  },
  '&.Mui-selected': {
    bgcolor: 'secondary.200'
  },
  '&:hover, &.Mui-focusVisible, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible': {
    bgcolor: 'primary.main',
    color: '#fff'
  }
};
export default function ProfileSection() {
  const {
    user,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const {
    pathname
  } = useLocation();
  const [anchor, setAnchor] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const open = Boolean(anchor);
  const initials = (user.name || user.email || '').trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  const close = () => {
    if (!busy) setAnchor(null);
  };
  const handleLogout = async () => {
    setBusy(true);
    setError(false);
    try {
      await logout();
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  };
  return <>
            <Chip component="button" type="button" aria-label={t("Abrir menu de conta e definições")} aria-controls={open ? 'account-menu' : undefined} aria-haspopup="menu" aria-expanded={open} icon={<Avatar src={user.picture || undefined} alt={t("")} sx={{
      width: 34,
      height: 34,
      ml: '8px !important',
      bgcolor: 'secondary.200',
      color: 'primary.main'
    }}>
                        {initials}
                    </Avatar>} label={<IconSettings aria-hidden="true" stroke={1.5} size="1.5rem" />} variant="outlined" onClick={event => setAnchor(event.currentTarget)} sx={{
      height: 48,
      borderRadius: '27px',
      cursor: 'pointer',
      borderColor: 'primary.light',
      bgcolor: 'primary.light',
      color: 'primary.main',
      '&&.MuiChip-clickable:hover, &&.Mui-focusVisible, &&[aria-expanded="true"]': {
        borderColor: 'primary.main',
        bgcolor: 'primary.main',
        color: '#fff'
      },
      '& .MuiChip-label': {
        lineHeight: 0
      }
    }} />
            <Menu id="account-menu" anchorEl={anchor} open={open} onClose={close} anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }} transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }} slotProps={{
      paper: {
        sx: {
          mt: 1.75,
          p: 1,
          width: 332,
          maxWidth: 'calc(100vw - 32px)',
          borderRadius: '12px',
          boxShadow: 16
        }
      }
    }}>
                <Box sx={{
        px: 2,
        pt: 1,
        pb: 2
      }}>
                    <Typography variant="h4" sx={{
          color: 'primary.main',
          overflowWrap: 'anywhere'
        }}>{user.name || user.email}</Typography>
                    <Typography variant="body2" sx={{
          mt: 0.5,
          overflowWrap: 'anywhere'
        }}>{user.email}</Typography>
                </Box>
                <Divider />
                {portalConfig.routes.filter(route => route.accountMenu).map(route => {
        const Icon = icons[route.id];
        return <MenuItem key={route.id} selected={pathname === route.path} disabled={busy} onClick={() => {
          close();
          navigate(route.path);
        }} sx={accountItemSx}>
                            <ListItemIcon sx={{
            color: 'inherit !important'
          }}>
                                <Icon stroke={1.5} size="1.3rem" />
                            </ListItemIcon>
                            <ListItemText primary={t(route.title)} />
                        </MenuItem>;
      })}
                <MenuItem disabled={busy} onClick={handleLogout} sx={accountItemSx}>
                    <ListItemIcon sx={{
          color: 'inherit !important'
        }}><IconLogout stroke={1.5} size="1.3rem" /></ListItemIcon>
                    <ListItemText primary={busy ? t('A terminar sessão…') : t('Terminar sessão')} />
                </MenuItem>
                {t(error) && <Box sx={{
        px: 1,
        pb: 1
      }}><Alert severity="error">{t("Não foi possível terminar a sessão. Tente novamente.")}</Alert></Box>}
            </Menu>
        </>;
}
